export default "__VITE_ASSET__DNZpiv9F__"